import { Button, ButtonGroup, Link } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import React from "react";
import Env from "../../Env";

const GenerationEnvSwitcher = (props) => {
  const {
    isProd, pageType, handleChangeEnv,
    prodContent, pageId, token, publishing, handlePublishPageConfirm
  } = props;
  const pdfUrl = new URL(Env.getBackendURL() + 'page/asPdf');
  pdfUrl.searchParams.append('store', Env.getStoreName());
  pdfUrl.searchParams.append('page_id', pageId);
  pdfUrl.searchParams.append('token', token);

  return (
    <div className="actionBar">
      <ButtonGroup segmented>
        <Button pressed={!isProd} onClick={handleChangeEnv(pageType)}><CsI18n>Draft</CsI18n></Button>
        <Button pressed={isProd} onClick={handleChangeEnv(pageType)}><CsI18n>Production</CsI18n></Button>
      </ButtonGroup>

      {isProd && !!prodContent &&
      <GenerationProductionActions
        pageId={pageId} publishing={publishing} token={token} handlePublishPageConfirm={handlePublishPageConfirm}
      />}
    </div>
  );
}

const GenerationDraftActions = (props) => {
  const { pageType, saving, editorReady, hasTemplate, handleToggleModalTemplate, handleDiscardChange, handleSavePage } = props;

  return (
    <div className="actionBar">
      <ButtonGroup>
        <Button destructive onClick={handleDiscardChange(pageType)}><CsI18n>Discard</CsI18n></Button>
        {hasTemplate() &&
        <Button onClick={handleToggleModalTemplate}><CsI18n>Use template</CsI18n></Button>}
      </ButtonGroup>
      <ButtonGroup>
        <Button primary onClick={handleSavePage(pageType)} loading={saving} disabled={!editorReady}>
          <CsI18n>Save</CsI18n>
        </Button>
      </ButtonGroup>
    </div>
  );
}

const GenerationProductionActions = ({ pageId, publishing, token, handlePublishPageConfirm }) => {
  // Construct PDF URL
  const pdfUrl = new URL(Env.getBackendURL() + 'page/asPdf');
  pdfUrl.searchParams.append('store', Env.getStoreName());
  pdfUrl.searchParams.append('page_id', pageId);
  pdfUrl.searchParams.append('token', token);

  return (
    <ButtonGroup>
      <Link url={pdfUrl.href} external>
        <CsI18n>Download as PDF</CsI18n>
      </Link>
      <Button primary loading={publishing} onClick={handlePublishPageConfirm}><CsI18n>Publish</CsI18n></Button>
    </ButtonGroup>
  );
}

export { GenerationEnvSwitcher, GenerationDraftActions };
